module.exports = __webpack_public_path__ + "img/lightning.6f20cc52.png";